import styled from "styled-components";

export const PromosLegalsWrapper = styled.div<{ isMobile: boolean }>`
  background-color: var(--fd-colors-background-base);
  ${({ isMobile }) => isMobile && `padding-bottom: var(--fd-space-space-2);`}
`;

export const PromosLegalsContainer = styled.div<{
  expanded: boolean;
  showGradient: boolean;
}>`
  position: relative;
  font-size: var(--fd-font-sizes-font-size-040);
  line-height: 125%;
  color: var(--fd-colors-content-default);
  background-color: var(--fd-colors-background-surface);
  margin: 0 auto;
  overflow: hidden;
  max-height: ${({ expanded }) =>
    expanded ? "none" : "calc(15px * 20 + 16px)"}; /* 20 lines + padding */
  transition: max-height 0.3s ease;
  padding: var(--fd-space-space-4);

  /* Fade effect for the last 5 lines in collapsed state */
  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${({ expanded }) =>
      expanded ? "0" : "90px"}; /* Approximate height of 5 lines */
    background: ${({ showGradient }) =>
      showGradient
        ? `linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 0%,
            var(--fd-colors-background-surface) 100%
          )`
        : "none"};
    pointer-events: none;
    transition: height 0.3s ease;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--fd-colors-background-surface);
  padding-bottom: var(--fd-space-space-4);
`;
